import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { RegimenFiscalRedux } from '../Redux/RegimenFiscalRedux'

const RegimenFiscalCrudObservable = createCRUDObservable({
  mainRedux: RegimenFiscalRedux,
  reduxPath: 'regimenFiscal',
  dataHandlers: {
    get: response => response.data.data,
  },
})

export const RegimenFiscalObservers = Object.assign({}, RegimenFiscalCrudObservable.observers, {})

export const RegimenFiscalEpic = combineEpics(
  RegimenFiscalCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/RegimenFiscalObservable.js